
import { Action } from 'vuex-class'
import { gmapApi } from 'gmap-vue'
import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import { PronosticoHidricoEstacionApi } from '@/domain/entities/Api'
import GmapOverlayViewer from '@/components/GmapOverlayViewer.vue'
import AutoCompleteViewer from '@/components/AutoCompleteViewer.vue'
import { GoogleMapOverlay, InfoView } from '@/store/modules/google-maps/types'
import { INFOVIEW_CLOSED } from '@/EventConstants'
import GroundOverlayViewer from '@/components/GroundOverlayViewer.vue'
import blueMarker from '../../public/img/icons/marker-blue.png'
import redMarker from '../../public/img/icons/marker-red.png'
import greenMarker from '../../public/img/icons/marker-green.png'
import orangeMarker from '../../public/img/icons/marker-orange.png'
import MarkerOptions = google.maps.MarkerOptions

const GOOGLE_MAPS_MODULE = 'googleMaps'

@Component({
  components: {
    AutoCompleteViewer,
    GmapOverlayViewer,
    GroundOverlayViewer,
    'info-view': () => import(/* webpackChunkName: "info-view" */ './InfoView.vue')
  }
})
export default class TheMap extends Vue {
  @Prop({ type: Array }) overlays!: GoogleMapOverlay
  @Prop({ type: Array }) groundOverlays!: GoogleMapOverlay
  @Prop({ type: Number, default: 10 }) zoom!: number
  @Prop({ type: Object }) position!: Position
  @Prop({ type: Array }) markers!: MarkerOptions[]
  @Prop({ type: Object }) infoView!: InfoView
  @Prop({ type: Object }) autocomplete!: { shown: boolean }
  @Prop({ type: Boolean, default: true }) openDefaultMarkerOption!: boolean
  @Prop({ type: String, default: '' }) defaultMarker!: string
  @Prop({ type: Object,
    default: {
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      disableDefaultUi: false,
      zoomControlOptions: {
        position: 3 // ControlOptions.TOP_RIGHT
      }
    } }) mapOptions!: google.maps.MapOptions
  @Prop({ type: Object }) pronosticoHidricoEstacion!: PronosticoHidricoEstacionApi
  @Action('setPosition', { namespace: GOOGLE_MAPS_MODULE })
  private setPosition: any
  @Action('setInfoViewStatus', { namespace: GOOGLE_MAPS_MODULE })
  private setInfoViewStatus: any
  @Ref() readonly mapRef!: any
  @Ref() readonly infoWindow!: any
  map!: google.maps.Map
  infoViewOpened: boolean = false
  markerPosition!: Position
  markerIndex: number = -1
  markerID: string = ''
  pixelOffset!: any

  get computedMapOptions () {
    return this.mapOptions
  }

  get google (): any {
    return gmapApi()
  }

  created () {
    this.markerPosition = { ...this.position }
  }

  getIconMarker (color: string) {
    switch (color) {
      case 'blue':
        return blueMarker
      case 'red':
        return redMarker
      case 'green':
        return greenMarker
      case 'orange':
        return orangeMarker
      default:
        return redMarker
    }
  }

  visibleMarkers (map: google.maps.Map) {
    const bounds = map.getBounds()
    return this.markers.filter(marker => {
      return marker.position && bounds && bounds.contains(marker.position)
    })
  }

  openDefaultMarker (map: google.maps.Map) {
    if (map && this.openDefaultMarkerOption) {
      let marker: any = this.visibleMarkers(map)[0]
      let markerIndex = 0
      if (this.defaultMarker !== '') {
        // marker = this.visibleMarkers(map).filter((m: any) => m.id.toString() === this.defaultMarker.toString())[0]
        // markerIndex = this.visibleMarkers(map).findIndex((m: any) => m.id.toString() === this.defaultMarker.toString())
        marker = this.markers.filter((m: any) => m.id.toString() === this.defaultMarker.toString())[0]
        markerIndex = this.markers.findIndex((m: any) => m.id.toString() === this.defaultMarker.toString())
      }
      if (marker) {
        this.selectMarker({ marker, index: markerIndex })
      }
    }
  }

  mounted () {
    const close = this.closeInfoWindow
    this.mapRef.$mapPromise.then((map: google.maps.Map) => {
      this.map = map
      this.map.addListener('click', close)
      this.$root.$on(INFOVIEW_CLOSED, (): void => { this.infoViewOpened = false })
    })
  }
  @Watch('markers')
  onMarkerChanged (newMarkers: any) {
    // TODO: find a better way to expect Google's markers to change
    setTimeout(() => this.openDefaultMarker(this.map), 1000)
  }

  async selectMarker ({ marker, index } : {marker: MarkerOptions | any, index: number }) {
    this.markerPosition = marker.position
    this.markerIndex = index
    this.markerID = marker.id
    await this.setInfoViewStatus({ active: false, selectedMarker: '' })
    await this.setInfoViewStatus({ active: true, selectedMarker: marker.id })
  }

  setPlace (place: any) {
    const position = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng()
    }
    this.setPosition({ position, zoom: 10 })
  }

  closeInfoWindow () {
    this.setInfoViewStatus({ active: false, selectedMarker: 0 })
  }
}
